import { useTranslation } from 'react-i18next';
import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';

import { CustomIcon } from '../icon';

export const BadgeImportant = (props: BadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge
      data-testid='badge-important'
      textTransform='capitalize'
      borderRadius='xl'
      backgroundColor='secondary200'
      px={1.5}
      display='flex'
      gap={0.5}
      alignItems='center'
      color='secondary600'
      {...props}>
      <CustomIcon name='star' size={10} solid color='secondary400' />
      {t('common:important')}
    </Badge>
  );
};
